module.exports = __webpack_public_path__ + "static/media/amex-logo.ecbc630c.svg";